<template>
    <div>
        <el-table
            class="rounded"
            empty-text="Nenhum distribuidor encontrado." 
            :data="data" 
            align="center" 
            border
            row-key="id"
            v-loading="isLoading"
            :expand-row-keys="expandedRows"
            @expand-change="handleExpand"
        >
            <!-- Expand -->
            <el-table-column type="expand">
                <div slot-scope="scope">
                    <div class="px-3">
                        <el-row :gutter="12">
                            <el-col :span="10">
                                <el-card>
                                    <el-descriptions title="Informações" :column="4" size="mini" :border="true">
                                        <template slot="extra">
                                            <div class="d-flex">
                                                <el-button 
                                                    v-if="isAuthorized"
                                                    type="success" 
                                                    size="mini" 
                                                    plain
                                                    :disabled="isLoading"
                                                    @click="dispatchLoginAs(scope.row.id)"
                                                >
                                                    <i v-if="isLoading" class="el-icon-loading"></i>
                                                    <i v-else class="fas fa-sign-in-alt"></i>
                                                    Logar como
                                                </el-button>
                                                <el-button 
                                                    v-if="isAuthorized"
                                                    type="warning"
                                                    size="mini"
                                                    plain
                                                    :disabled="isLoading"
                                                    @click="dispatchChangePassword(scope.row.id)"
                                                >
                                                    <i v-if="isLoading" class="el-icon-loading"></i>
                                                    <i v-else class="fas fa-key"></i>
                                                    Alterar senha
                                                </el-button>
                                            </div>
                                        </template>

                                        <el-descriptions-item :span="4">
                                            <template slot="label">Distribuidor</template>
                                            <div class="d-flex align-items-center justify-content-between">
                                                <span>{{ scope.row.nome }}</span>
                                                <div class="d-flex align-items-center">
                                                    <el-tag class="mr-2" type="info" size="mini">#{{ scope.row.codigo }}</el-tag>
                                                    <el-button size="mini" circle @click="copyThis(scope.row.codigo)">
                                                        <i class="el-icon-document-copy"></i>
                                                    </el-button>
                                                </div>
                                            </div>
                                        </el-descriptions-item>

                                        <el-descriptions-item :span="4">
                                            <template slot="label">Classe</template>
                                            <el-tag size="mini">{{ scope.row.classe || '-' }}</el-tag>
                                        </el-descriptions-item>

                                        <el-descriptions-item v-if="distributor && distributor.pessoa_fisica" :span="4">
                                            <template slot="label">CPF</template>
                                            <div class="d-flex align-items-center justify-content-between">
                                                <div>
                                                    <el-skeleton v-if="isLoading"/>
                                                    <span v-else>{{ distributor.pessoa_fisica.cpf || '-' }}</span>
                                                </div>
                                                <el-button v-if="distributor.cpf" size="mini" circle @click="copyThis(distributor.pessoa_fisica.cpf)">
                                                    <i class="el-icon-document-copy"></i>
                                                </el-button>
                                            </div>
                                        </el-descriptions-item>

                                        <el-descriptions-item v-else-if="distributor && distributor.pessoa_juridica" :span="4">
                                            <template slot="label">CNPJ</template>
                                            <div class="d-flex align-items-center justify-content-between">
                                                {{ distributor.pessoa_juridica.cnpj || '-' }}
                                                <el-button v-if="distributor.pessoa_juridica.cnpj" size="mini" circle @click="copyThis(distributor.pessoa_juridica.cnpj)">
                                                    <i class="el-icon-document-copy"></i>
                                                </el-button>
                                            </div>
                                        </el-descriptions-item>
                                    </el-descriptions>
                                </el-card>
                            </el-col>

                            <el-col :span="14">
                                <el-card>
                                    <el-descriptions title="Contato" :column="4" size="mini" :border="true">
                                        <template slot="extra">
                                            <div class="d-flex">
                                                <i v-if="isLoading" class="el-icon-loading"></i>
                                            </div>
                                        </template>

                                        <el-descriptions-item :span="4">
                                            <template slot="label">
                                                <i clsas="fas fa-envelope"></i>
                                                E-mail
                                            </template>
                                            <div class="d-flex align-items-center justify-content-between">
                                                <el-tag type="info" size="mini">{{ scope.row.email || '-' }}</el-tag>
                                                <el-button size="mini" circle @click="copyThis(scope.row.email)">
                                                    <i class="el-icon-document-copy"></i>
                                                </el-button>
                                            </div>
                                        </el-descriptions-item>

                                        <template v-if="distributor && distributor.contatos.length > 0">
                                            <el-descriptions-item 
                                                v-for="(contact, index) in distributor.contatos" 
                                                :key="contact.id"
                                                :span="2"
                                            >
                                                <template slot="label">
                                                    {{ contact.telefone.tipo == 'F' ? 'Fixo' : 'Celular' }}
                                                </template>
                                                <div class="d-flex align-items-center justify-content-between">
                                                    <el-tag size="mini">({{ contact.telefone.ddd }}) {{ contact.telefone.numero }}</el-tag>
                                                    <el-button size="mini" circle @click="copyThis(`(${contact.ddd})$ {contact.numero}`)">
                                                        <i class="el-icon-document-copy"></i>
                                                    </el-button>
                                                </div>
                                            </el-descriptions-item>
                                        </template>

                                        <el-descriptions-item v-else :span="4">
                                            <template slot="label">Contatos</template>
                                            -
                                        </el-descriptions-item>

                                        <el-descriptions-item 
                                            v-if="distributor && distributor.endereco.endereco_formatado" 
                                            :span="4"
                                        >
                                            <template slot="label">
                                                Endereço
                                            </template>
                                            {{ distributor.endereco.endereco_formatado }}
                                        </el-descriptions-item>
                                    </el-descriptions>
                                </el-card>
                            </el-col>
                        </el-row>
                    </div>
                </div>
            </el-table-column>
            
            <!-- ID -->
            <el-table-column 
                v-if="isAuthorized"
                label="ID" 
                width="80"
                prop="id" 
                align="left"
            >
                <div slot-scope="scope">{{ scope.row.id }}</div>
            </el-table-column>

            <!-- Codigo -->
            <el-table-column label="#Código" width="120" align="center">
                <template slot-scope="scope">
                    <span>{{ scope.row.codigo }}</span>
                </template>
            </el-table-column>

            <!-- Nome -->
            <el-table-column min-width="320" label="Nome" align="left">
                <template slot-scope="scope">
                    <span>{{ scope.row.nome }}</span>
                </template>
            </el-table-column>

            <!-- Classe -->
            <el-table-column label="Classe" width="70" align="center">
                <template slot-scope="scope">
                    <el-tag size="small">{{ scope.row.classe }}</el-tag>
                </template>
            </el-table-column>

            <!-- Cidade/Uf -->
            <el-table-column label="Cidade/Estado" width="220" align="left">
                <template slot-scope="scope">
                    <span>{{ scope.row.cidade }} - {{ scope.row.uf }}</span>
                </template>
            </el-table-column>

            <!-- Status -->
            <el-table-column label="Status" width="140" align="left">
                <template slot-scope="scope">
                    <el-tag 
                        v-if="scope.row.status"
                        type="info" 
                        size="small"
                        :type="scope.row.status === 'Ativo' 
                            ? 'success' 
                            : (scope.row.status == 'Inativo' ? 'warning' : 'danger')"
                    >
                        {{ scope.row.status.toUpperCase() }}
                    </el-tag>
                </template>
            </el-table-column>

            <!-- Criado em -->
            <el-table-column label="Criado em" width="110" align="center">
                <template slot-scope="scope">
                    <div class="d-flex align-items-center justify-content-center">
                        <i class="el-icon-time"></i>
                        <span class="ml-1">{{ formatDate(scope.row.created_at) }}</span>
                    </div>
                </template>
            </el-table-column>

            <!-- Atualizado em -->
            <el-table-column label="Última atualização" width="160" align="center">
                <template slot-scope="scope">
                        <div class="d-flex align-items-center justify-content-center">
                        <i class="el-icon-time"></i>
                        <span class="ml-1">{{ formatDate(scope.row.updated_at) }}</span>
                    </div>
                </template>
            </el-table-column>

            <!-- Acoes -->
            <el-table-column 
                fixed="right"
                :width="50"
                align="right"
            >
                <div slot="header" style="width: 100%;">
                    <i class="el-icon-menu" />
                </div>
                <template slot-scope="scope">
                    <div class="d-flex justify-content-between">
                        <el-popover placement="bottom-end" trigger="hover">
                            <el-button
                                slot="reference"
                                size="mini" 
                                type="info" 
                                plain 
                                circle
                                :disabled="isLoading"
                            >
                                <i class="el-icon-more"></i>
                            </el-button>

                            <div :style="{ display: 'flex', alignItems: 'flex-start', flexDirection: 'column', gap: '4px', maxWidth: '300px' }">
                                <span class="font-weight-bold">Ações</span>
                                <el-divider class="my-1"></el-divider>

                                <div :style="{ width: '100%'}">
                                    <el-button
                                        size="mini" 
                                        type="primary" 
                                        plain 
                                        :disabled="isLoading"
                                        @click.native.prevent="goToShowPage(scope.row.id)"
                                    >
                                        <i class="el-icon-right"></i>
                                        Ver Distribuidor
                                    </el-button>
                                </div>

                                <div v-if="isAuthorized" :style="{ width: '100%'}">
                                    <el-button
                                        size="mini" 
                                        type="success" 
                                        plain
                                        :disabled="isLoading"
                                        @click.native.prevent="dispatchLoginAs(scope.row.id)"
                                        :style="{ width: '100%' }"
                                    >
                                        <i class="fas fa-sign-in-alt"></i>
                                        Logar como
                                    </el-button>
                                </div>
                            </div>
                        </el-popover>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        
        <!-- Paginacao -->
        <el-row class="mt-3">
            <el-col>
                <el-pagination
                    background
                    :current-page.sync="pagination.data.currentPage"
                    :page-sizes="pagination.pageSizes"
                    :page-size="pagination.data.perPage"
                    layout="total, sizes, prev, pager, next"
                    :total="pagination.total"
                    @current-change="handlePageChange"
                    @size-change="handleSizeChange"
                />
            </el-col>
        </el-row>

        <!-- ChangePassword -->
        <DistribuidorChangePassword ref="changePassword"/>

        <!-- LoginAs -->
        <DistribuidorLoginAs ref="loginAs"/>
    </div>
</template>
<script>
    // Components
    import {
        Empty,
        Table,
        TableColumn,
        Notification,
        Popover,
        Tag,
        Divider,
        Tooltip,
        RadioGroup,
        RadioButton,
        Dropdown,
        DropdownMenu,
        DropdownItem,
        Pagination,
    } from "element-ui";

    import CardIndicator from "@/components/_micro/Card/CardIndicator.vue";

    import DistribuidorChangePassword from "./DistribuidorChangePassword.vue";
    import DistribuidorLoginAs from "./DistribuidorLoginAs.vue";

    // Api
    import { DistribuidorApi } from "@/api/DistribuidorApi.js";
    const distribuidorApi = new DistribuidorApi();

    // Utils
    import { copyThis } from "@/util/copyThis.js";
    import { formatDate } from "@/util/formatters";

    export default {
        name: "distribuidor-list",
        data() {
            return {
                data: [],
                isLoading: false,
                expandedRows: [],
                filters: {
                    ativo: null,
                    orderBy: 'latest',
                },
                pagination: {
                    data: {
                        currentPage: 1,
                        perPage: 15,
                    },
                    pageSizes: [15, 50, 75, 100],
                    total: 0
                },
                distributor: null,
            }
        },
        methods: {
            async fetch() {
                this.isLoading = true;

                try {
                    
                    const res = await distribuidorApi.list({
                        ...this.filters,
                        ...this.pagination.data
                    });

                    this.data = res.data;
                    this.pagination.total = res.total;
                } catch (error) {
                    Notification.error({
                        title: 'Erro',
                        message: 'Não foi possível obter os distribuidores. Algo inesperado ocorreu!'
                    });
                } finally {
                    this.isLoading = false;
                }
            },
            /**
             * Confirmar envio
             */
            async dispatchNotificacaoConfirmSubmit(id) {
                this.$refs.notificacaoConfirmSubmit.selectedId = id;

                const elLoading = this.$loading({ lock: true })

                await this.$refs.notificacaoConfirmSubmit.show();

                elLoading.close();

                return this.$refs.notificacaoConfirmSubmit.toggleModal();
            },
            
            /** ChangePassword */
            async dispatchChangePassword(id) {
                this.$refs.changePassword.id = id;

                const elLoading = this.$loading({ lock: true })

                await this.$refs.changePassword.show();

                elLoading.close();

                return this.$refs.changePassword.toggleModal();
            },

            /** LoginAs */
            async dispatchLoginAs(id) {
                this.$refs.loginAs.selectedId = id;

                const elLoading = this.$loading({ lock: true })

                await this.$refs.loginAs.show();

                elLoading.close();

                return this.$refs.loginAs.toggleModal();
            },

            // Direciona para pagina do distribuidor
            goToShowPage(id) {
                window.location.assign(`/adm/distribuidores/${id}`);
            },
            // Expande a linha da tabela e busca os dados do distribuidor
            async handleExpand(row, expandedRows) {
                // Linha foi fechada
                if (!expandedRows.some(item => item.id === row.id)) {
                    this.expandedRows = [];
                    return;
                }

                // Mantém apenas esta linha aberta
                this.expandedRows = [row.id];

                // Busca os dados da linha
            //    await this.getDistributorById(row.id)
            },

            /*
             * Pagination
             */
            handlePageChange(page) {
                this.pagination.data.currentPage = page;
                this.fetch();
            },
            handleSizeChange(val) {
                this.pagination.data.perPage = val;
                this.pagination.data.currentPage = 1;
                this.fetch();
            },
            /** Utils */
            formatDate,
            copyThis
        },
        computed: {
            isAuthorized() {
                return this.$store.getters['user/isAnyRole'](['adm', 'comercial']);
            },
        },
        watch: {
            "filters": {
                deep: true,
                handler() {
                    this.pagination.data.currentPage = 1;
                    this.fetch();
                },
            }
        },
        mounted() {
            this.fetch();
        },
        components: {
            [Empty.name]: Empty,
            [Table.name]: Table,
            [TableColumn.name]: TableColumn,
            [Notification.name]: Notification,
            [Popover.name]: Popover,
            [Tag.name]: Tag,
            [Divider.name]: Divider,
            [Tooltip.name]: Tooltip,
            [RadioGroup.name]: RadioGroup,
            [RadioButton.name]: RadioButton,
            [Dropdown.name]: Dropdown,
            [DropdownMenu.name]: DropdownMenu,
            [DropdownItem.name]: DropdownItem,
            [Pagination.name]: Pagination,
            DistribuidorChangePassword,
            DistribuidorLoginAs,
            CardIndicator,
            // NotificacaoCreateModal,
            // NotificacaoEditModal,
            // NotificacaoDeleteModal,
            // NotificacaoConfirmSubmitModal,
        },
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/_internal/distribuidor/DistribuidorList.vue